import BookingListTemplate from "../../../templates/admin/bookingList";

const BookingListScreen = () => {
  return <BookingListTemplate />;
};

export default BookingListScreen;
